import { useState } from 'react';
import { Plus, X } from 'lucide-react';

export default function FaqItem(props) {
  const [isDetail, setIsDetail] = useState(false);

  return (
    <div className="py-1">
      <div className="flex items-center justify-between space-x-4">
        <p className="font-[poppins] text-sm sm:text-lg text-[#181D27] font-semibold leading-[1.2]">
          {props.question}
        </p>
        <button
          type="button"
          onClick={() => setIsDetail((prev) => !prev)}
          className="cursor-pointer shrink-0 p-1 rounded-lg hover:bg-[#E8F0FF] transition-colors"
          aria-expanded={isDetail}
        >
          {isDetail ? (
            <X className="text-[#2A59C6] w-5 h-5 sm:w-6 sm:h-6" />
          ) : (
            <Plus className="text-[#2A59C6] w-5 h-5 sm:w-6 sm:h-6" />
          )}
        </button>
      </div>

      {isDetail && (
        <div className="transition-all duration-500 ease-in-out">
          <p className="lo-faq-answer pt-3 font-[poppins] text-xs sm:text-sm text-[#717680] font-normal leading-[1.5]">
            {props.answer}
          </p>
        </div>
      )}
    </div>
  );
}
